import React, { useEffect } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { type Theme } from "@mui/material/styles";
import { TextField } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { CronExpressionModal } from "../picker/CronExpressionModal";
import cronstrue from "cronstrue";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiFormLabel-root": {
				transform: "translate(14px, -6px) scale(0.75) ",
				backgroundColor: "#FFFF",
				transition: "none !important",
				left: -3.5,
				padding: "0 5px",
			},
			"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
				borderColor: "#3F51B5",
			},
			"& .MuiFormLabel-root.Mui-focused": {
				color: "#3F51B5",
			},
		},
		description: {
			marginBottom: theme.spacing(2),
			color: theme.palette.text.secondary,
		},
		title: {
			marginBottom: theme.spacing(1),
			fontWeight: 500,
		},
		formControl: {
			width: "100%",
			marginTop: theme.spacing(1),
		},
		expressionPreview: {
			marginTop: theme.spacing(2),
		},
		editButton: {
			marginTop: theme.spacing(2),
		},
	}),
);

interface CustomRecurrenceStepProps {
	cronExpression: string;
	onCronExpressionChange: (expression: string) => void;
	onGoBack?: () => void;
}

export const CustomRecurrenceStep: React.FC<CustomRecurrenceStepProps> = ({
	cronExpression,
	onCronExpressionChange,
	onGoBack,
}) => {
	const classes = useStyles();
	const [showCronModal, setShowCronModal] = React.useState(true);
	const [humanReadableExpression, setHumanReadableExpression] =
		React.useState("");

	useEffect(() => {
		try {
			if (cronExpression) {
				setHumanReadableExpression(cronstrue.toString(cronExpression));
			}
		} catch (error) {
			setHumanReadableExpression("Invalid CRON expression");
		}
	}, [cronExpression]);

	const handleModalClose = () => {
		if (!cronExpression && onGoBack) {
			onGoBack();
		} else {
			setShowCronModal(false);
		}
	};

	const handleModalSave = (cron: string) => {
		onCronExpressionChange(cron);
		setShowCronModal(false);
	};

	const handleEditClick = () => {
		setShowCronModal(true);
	};

	return (
		<Grid2 container spacing={2}>
			{showCronModal && (
				<Grid2 size={{ xs: 12 }}>
					<CronExpressionModal
						show={showCronModal}
						onClose={handleModalClose}
						value={cronExpression}
						onChange={handleModalSave}
					/>
				</Grid2>
			)}

			{!showCronModal && (
				<>
					<Grid2
						className={classes.expressionPreview}
						onClick={handleEditClick}
						size={{ xs: 12 }}
					>
						<TextField
							style={{ cursor: "pointer" }}
							label="Schedule Expression"
							variant="outlined"
							fullWidth
							value={humanReadableExpression}
							slotProps={{
								input: {
									readOnly: true,
								},
							}}
						/>
					</Grid2>
				</>
			)}
		</Grid2>
	);
};
